const isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined'

const isNode =
  typeof process !== 'undefined' && process.versions != null && process.versions.node != null

/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */
const isJsDom =
  (typeof window !== 'undefined' && window.name === 'nodejs') ||
  (typeof navigator !== 'undefined' && navigator.userAgent.includes('jsdom'))

const isClient = isBrowser && !isJsDom

const isDevelopment = process.env.NODE_ENV === 'development'

const isProductionEnv = process.env.NODE_ENV === 'production'

export { isBrowser, isNode, isJsDom, isClient, isDevelopment, isProductionEnv }
